import React, { useState, useEffect, memo, useRef } from "react";
import { Image, Modal, Form, Col, Button } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import axiosInstance from "../../axios/axios";
import { Decrypt_Value, Encrypt_Value } from "../../MiddleWare/EncryptDecrypt";
import { Select, Tooltip } from "antd";
import AlertMsgIcon from "../../assets/images/AlertMsgIcon.png";
import { FormLabel, Input } from "../patient/StyledComponent";
import CustomSuffixIcon from "./CustomSuffixIcon";
import { AutoComplete } from "antd";
import axios from "axios";
import {
  Div1 as Div,
  Span,
} from "../setting/PatientPortalSettings/StyledComponents";
import { fileurl } from "../../axios/url.js";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min.js";
import { Popup } from "semantic-ui-react";
import GetStartedPopup from "./GetStartedPopup.js";
import { PhoneNumberFormat, PhoneNumberUtil } from "google-libphonenumber";
import { Switch } from "antd";
import countries from "../PhoneInput/countries.js";
import PhoneInput from "../PhoneInput/PhoneInput.js";
import zIndex from "@material-ui/core/styles/zIndex.js";
import { IoCloseSharp } from "react-icons/io5";

const CreateClient = ({
  setTemShow = () => {},
  clientShow,
  dataFetch,
  ClientAdd,
  ClientFailed,
  setappshow = () => {},
  ClientFailed1,
  openIntake,
}) => {
  //-------------------------------------------State and Variables Start-------------------------------------------------------- //
  const { Option } = Select;

  let history = useHistory();
  const [countryCodes, setCountryCodes] = useState([]);

  const handleClose = () => {
    clientShow(false);
    setTemShow(true);
  };
  const [externalID, setExternalID] = useState("");
  const [first_name, setfirstname] = useState("");
  const [last_name, setlastname] = useState("");
  const [email_id, setemailid] = useState("");
  const [phone_number, setphonenumber] = useState("");
  const [providerID, setproviderID] = useState("");
  const [providerlist, getproviderlist] = useState([]);
  const [fnError, setFnError] = useState(false);
  const [lnError, setLnError] = useState(false);
  const [mailError, setMailError] = useState(false);
  const [mailError1, setMailError1] = useState(false);
  const [phoneError, setPhoneError] = useState(false);
  const [idError, setIdError] = useState(false);
  const [provErr, setProvErr] = useState(false);
  const [mailErrMsg, setMailErrMsg] = useState("");
  const [disable, setDisable] = useState(false);
  const [sameNumber, setSameNumber] = useState(false);
  const [showPhoneFailModal, setShowPhoneFailModal] = useState(false);
  const [phoneErrMsg, setPhoneErrMsg] = useState(false);
  const [showOptions, setShowOptions] = useState(false);
  const [search, setSearch] = useState("");
  const [codeCountry, setCodeCountry] = useState("");
  const [codeOnly, setCodeOnly] = useState("");
  const [mobileErr, setMobileErr] = useState(false);
  const [countryErr, setCountryErr] = useState("");
  const [countrywithNumber, setcountrywithNumber] = useState(false);
  const [mailErrorVal, setmailErrorVal] = useState(false);
  const [mailErrorReq, setMailErrorReq] = useState(true);
  const Locationdata = useLocation();
  const step = new URLSearchParams(Locationdata.search).get("step");
  const [showStepThreeIntro, setShowStepThreeIntro] = useState(false);
  const [showStepFourIntro, setShowStepFourIntro] = useState(false);
    const [modalScrollTick, setModalScrollTick] = useState(0);
  const clientCreateRef = useRef(null);
  const [isIntakeFlow, setIsIntakeFlow] = useState(false);
  const [PatientDis, setPatientDis] = useState(false);

  const lastKeyPressed = useRef();
  const phoneUtil = PhoneNumberUtil.getInstance();

  const storedNames = Decrypt_Value(localStorage.getItem("setroles"), "vozo");
  const userID = Decrypt_Value(localStorage.getItem("user_id"), "vozo");
  const authorized = Decrypt_Value(localStorage.getItem("authorized"), "vozo");
  const main_pro = Decrypt_Value(localStorage.getItem("main_pro"), "vozo");
  const owner_id = Decrypt_Value(localStorage.getItem("owner_id"), "vozo");

  const [enablePortal, setEnablePortal] = useState(false);
  const [portalErrMsg, setPortalErrMsg] = useState("");

  const [clientPhone, setClientPhone] = useState({
    country: countries.find((c) => c.iso === "US"), // or IN if needed
    number: "",
  });

  //-------------------------------------------State and Variables End -------------------------------------------------------- //

  // ------------------------------- Functions Start--------------------------------------------------------- //

  const handleIntroNext = () => {
    console.log("Step 3 Next Clicked");
    console.log("Current Step:", step);
    setShowStepThreeIntro(false);
    if (isIntakeFlow) {
      setShowStepFourIntro(true);
      return;
    }
    handleClose();
    history.replace({
      pathname: "/schedule/nav/1",
      search: "?step=6.4",
    });
  };

  const handleIntroBack = () => {
    setShowStepThreeIntro(false);
    handleClose();
    history.replace({
      pathname: "/patient/patientlist",
      search: "?step=6.2",
    });
  };
  const mouseClick = () => {
    setShowOptions(!showOptions);
  };

  const changeCountryCode = (data) => {
    let values = data.split("-");

    const codevalues = values[1].replace(/[()+\s]/g, "");
    setSearch(data);
    setCodeCountry("+" + codevalues);
    setCodeOnly(values[2]);
    setCountryErr(false);
    setPhoneError(false);
  };

  const handleSearchChange = (data) => {
    setSearch(data);
    setCodeCountry("");
    setCodeOnly("");
  };
  const checkPhone = (e, mode) => {
    e.preventDefault();
    const checkPhone = new Promise((resolve, reject) => {
      handlephonechange(resolve, reject);
    });

    checkPhone
      .then((res) => {
        if (res === "break") {
          OnChangePhoneFail();
          throw new Error("number already used");
        }
      })
      .then(() => {
        if (mode === "more") {
          createSaveAddMore();
        } else {
          createSave();
        }
      })
      .catch((err) => {
        console.error("number already used");
      });
  };

  const createSave = async () => {
    if ((mailError || mailError1) && email_id.length !== 0) {
      return;
    }
    if (sameNumber) {
      OnChangePhoneFail();
      return;
    }
    const article = {
      fname: first_name,
      lname: last_name,
      email: email_id,
      phone:
        clientPhone.country.dialCode +
        "_" +
        clientPhone.number +
        "_" +
        clientPhone.country.iso,

      country_code: clientPhone.country.iso,
      external: externalID,
      prov_id: providerID,
      allow_patient_portal: enablePortal ? "YES" : "NO",
    };

    let err = 0;
    if (first_name === "" || first_name === null) {
      setFnError(true);
      err = 1;
    }
    if (last_name === "" || last_name === null) {
      setLnError(true);
      err = 1;
    }
    if (phoneError || countrywithNumber || mobileErr) {
      err = 1;
    }
    if (providerID === "" || providerID === null) {
      setProvErr(true);
      err = 1;
    }

    if (err > 0) {
      return;
    } else if (!idError) {
      setDisable(true);
      let Data_enc = Encrypt_Value(article, "vozo");
      axiosInstance
        .post("/vozo/patient", Data_enc)
        .then((response) => {
          if (response.data === "Duplicate email detected") {
            OnChangeClientFail1();
            setDisable(false);
          } else if (typeof response.data === "number") {
            clientShow(false);
            setTemShow(true);
            OnChangeClientAdd(
              enablePortal
                ? "Client created successfully and portal access mail sent"
                : "Client created successfully",
              () => {
                if (enablePortal) {
                  openIntake({
                    id: response.data,
                    name: first_name + " " + last_name,
                    email: email_id,
                  });
                } else {
                  setfirstname("");
                  setproviderID("");
                  setlastname("");
                  setemailid("");
                  setClientPhone({
                    country: countries.find((c) => c.iso === "US"),
                    number: "",
                  });
                  setExternalID("");
                  dataFetch();
                  setDisable(false);
                }
              },
            );
          } else {
            OnChangeClientFail();
            setfirstname("");
            setproviderID("");
            setlastname("");
            setemailid("");
            setphonenumber("");
            setExternalID("");
            setDisable(false);
          }
        })
        .catch((err) => {
          setIdError(true);
          setDisable(false);
        });
    }
  };
  const handleInput = (event) => {
    const input = event.target.value;
    const digitsOnly = input.replace(/\D/g, "");

    // Allow only digits and spaces, limit to 10 digits
    if (/^[\d\s]*$/.test(input) && digitsOnly.length <= 10) {
      try {
        const phoneNumber = phoneUtil.parseAndKeepRawInput(input, codeOnly);
        const isValid = phoneUtil.isValidNumber(phoneNumber);
        const isPossible = phoneUtil.isPossibleNumber(phoneNumber);

        if (isValid && isPossible) {
          setphonenumber(input);
          setcountrywithNumber(false);
        } else {
          setphonenumber(input);
          setcountrywithNumber(input !== "");
        }
      } catch (err) {
        setphonenumber(input);
        setcountrywithNumber(input !== "");
      }

      setMobileErr(false);
      setCountryErr(false);
      setSameNumber(false);
    }
  };

  const handlephonechange = (resolve, reject) => {
    if (clientPhone.number !== "") {
      let a = {
        value:
          clientPhone.country.dialCode +
          "_" +
          clientPhone.number +
          "_" +
          clientPhone.country.iso,
        pid: "none",
      };
      let data1 = Encrypt_Value(a, "vozo");
      axiosInstance
        .post("/vozonew/patphonecheck?type=patient", data1)
        .then((res) => {
          try {
            let data = Decrypt_Value(res.data, "vozo");
            if (data === "number not found") {
              setSameNumber(false);
              resolve("continue");
            } else if (data && data !== "number not found") {
              setSameNumber(true);
              setPhoneErrMsg(
                "This phone number is already used for an existing patient. Please use a different phone number.",
              );
              resolve("break");
            } else {
              setSameNumber(false);
              resolve("continue");
            }
          } catch (e) {
            // Decrypt failed = backend returned non-JSON (PHP array) = number exists
            setSameNumber(true);
            setPhoneErrMsg(
              "This phone number is already used for an existing patient. Please use a different phone number.",
            );
            resolve("break");
          }
        })
        .catch((err) => {
          console.error("Phone check error:", err);
          resolve("continue");
        });
    } else {
      resolve("continue");
    }
  };

  const createSaveAddMore = async () => {
    const article = {
      fname: first_name,
      lname: last_name,
      email: email_id,
      phone: clientPhone.number
        ? clientPhone.country.dialCode +
        "_" +
        clientPhone.number +
        "_" +
        clientPhone.country.iso
        : "",
      external: externalID,
      prov_id: providerID,
      allow_patient_portal: enablePortal ? "YES" : "NO",
    };
    let err = 0;
    if ((mailError || mailError1) && email_id.length !== 0) {
      err = 1;
    }
    if (sameNumber) {
      OnChangePhoneFail();
      err = 1;
    }
    if (first_name === "" || first_name === null) {
      setFnError(true);
      err = 1;
    }
    if (last_name === "" || last_name === null) {
      setLnError(true);
      err = 1;
    }
    if (providerID === "" || providerID === null) {
      setProvErr(true);
      err = 1;
    }
    if (phoneError || countrywithNumber || mobileErr) {
      err = 1;
    }
    if (err > 0) {
      return;
    } else {
      let Data_enc = Encrypt_Value(article, "vozo");
      setDisable(true);
      axiosInstance
        .post("/vozo/patient", Data_enc)
        .then((response) => {
          if (response.data === "Duplicate email detected") {
            OnChangeClientFail1();
            setDisable(false);
          } else if (typeof response.data === "number") {
            if (enablePortal) {
              openIntake({
                id: response.data,
                name: first_name + " " + last_name,
                email: email_id,
              });
            } else {
              setfirstname("");
              setproviderID("");
              setlastname("");
              setemailid("");
              setClientPhone({
                country: countries.find((c) => c.iso === "US"),
                number: "",
              });
              setExternalID("");
              setDisable(false);
              clientShow();
              setappshow(false);
              window.dispatchEvent(new CustomEvent("reload-patient-data"));
              history.push("/patient/demographics/" + response.data);
            }
          } else {
            OnChangeClientFail();
            setfirstname("");
            setproviderID("");
            setlastname("");
            setemailid("");
            setphonenumber("");
            setExternalID("");
            setDisable(false);
          }
        })
        .catch((err) => {
          setIdError(true);
          setDisable(false);
        });
    }
  };

  // const OnChangeClientAdd = (msg) => {
  //   ClientAdd(msg);
  //   setTimeout(() => {
  //     ClientAdd(false);
  //   }, 1800);
  // };
  const OnChangeClientAdd = (msg, onClose) => {
    ClientAdd({
      show: true,
      message: msg,
    });

    setTimeout(() => {
      ClientAdd({
        show: false,
        message: "",
      });
      if (onClose) onClose();
    }, 1800);
  };

  const OnChangeClientFail = () => {
    ClientFailed(true);
    setTimeout(() => {
      ClientFailed(false);
    }, 1000);
  };

  const OnChangeClientFail1 = () => {
    ClientFailed1(true);
    setTimeout(() => {
      ClientFailed1(false);
    }, 4000);
  };

  const OnChangePhoneFail = () => {
    setShowPhoneFailModal(true);
    setTimeout(() => {
      setShowPhoneFailModal(false);
    }, 4000);
  };

  const externalId = (e) => {
    const value = e.target.value;

    // Remove all spaces from the input
    if (value.includes(" ")) {
      return; // Block update if space is typed
    }
    if (!isNaN(e.target.value)) {
      setExternalID(e.target.value);
      setIdError(false);
    }
  };
  const timeout = (ms) => {
    return new Promise((resolve) => setTimeout(resolve, ms));
  };

  const EmailCheck = (e) => {
    const value = e.target.value;
    if (value.includes(" ")) {
      return;
    }
    // Always update the state first (to reflect UI correctly)
    setemailid(value);

    // If space is present, return early without validation

    const regex = /^[a-zA-Z0-9.]+@[a-zA-Z0-9]+\.[a-zA-Z]{1,4}$/;

    if (value === "" || regex.test(value)) {
      setmailErrorVal(false);
      setMailError(false);
      setMailErrorReq(value === "");
      setMailErrMsg("");
      setMailError1(false);
    } else {
      setMailError(true);
      setmailErrorVal(true);
      setMailErrorReq(false);
      setMailErrMsg("Enter valid e-mail address");
    }
  };

  const fnameSetVal = (e) => {
    const value = e.target.value;

    // Remove all spaces from the input
    if (value.includes(" ")) {
      return; // Block update if space is typed
    }
    setfirstname(e.target.value);
    setFnError(false);
  };

  const lnameSetVal = (e) => {
    const value = e.target.value;

    // Remove all spaces from the input
    if (value.includes(" ")) {
      return; // Block update if space is typed
    }
    setlastname(e.target.value);
    setLnError(false);
  };

  const provIdSetVal = (e) => {
    setproviderID(e);
    setProvErr(false);
  };

  const handlePortalChange = (checked) => {
    axiosInstance
      .get("/vozo/patient/clientportalaccess/data")
      .then((response) => {
        let data = Decrypt_Value(response.data, "vozo");

        setPatientDis(data[0][0].gl_value === "1" ? false : true);
      });
    if (checked) {
      if (!email_id || email_id.trim() === "") {
        setPortalErrMsg(
          "Patient email ID is missing. Add an email address to enable the patient portal.",
        );
      } else if (mailError || mailErrorVal || mailError1) {
        setPortalErrMsg(
          "Please enter a valid and unique email address to enable the patient portal.",
        );
      } else if (PatientDis) {
        setPortalErrMsg(
          "Patient portal access is not being enabled in your settings.",
        );
      } else {
        setPortalErrMsg("");
        setEnablePortal(checked);
      }
    } else {
      setPortalErrMsg("");
      setEnablePortal(checked);
    }
  };

  // ------------------------------- Functions End----------------------------------------------------------- //

  // ------------------------------- UseEffect Start ------------------------------------------------------- //
  useEffect(() => {
    const fetchApis = async () => {
      await axios
        .get(fileurl + "/interface/register/get_country_code_rpm.php")
        .then((res) => {
          setCountryCodes(res.data);
        })
        .catch((err) => {
          console.error(err);
          setCountryCodes([]);
        });

      let Data_frsh =
        "limit=40&authorized=" +
        authorized +
        "&main_pro=" +
        main_pro +
        "&owner_id=" +
        owner_id +
        "&userID=" +
        userID +
        "&pat_share=" +
        storedNames.pat_g;

      let Data_enc = Encrypt_Value(Data_frsh, "vozo");
      await axiosInstance
        .get("/vozonew/provider?search=" + Data_enc)
        .then((response) => {
          let DecodeVal = Decrypt_Value(response.data, "vozo");
          getproviderlist(DecodeVal);
        })
        .catch((err) => {
          getproviderlist([]);
        });
    };

    fetchApis();
  }, []);

  // useEffect(() => {
  //   if (clientPhone.country && clientPhone.number !== "") {
  //     axios
  //       .post(fileurl + "/interface/register/validatephonenumber.php", {
  //         phone_number: clientPhone.number,
  //         country_code: clientPhone.country.iso,
  //       })

  //       .then((res) => {
  //         if (res.data === "invalid") {
  //           setMobileErr(true);
  //         } else {
  //           setMobileErr(false);
  //         }
  //       })
  //       .catch((err) => {
  //         console.error(err);
  //         setMobileErr(false);
  //       });
  //   } else {
  //     setMobileErr(false);
  //     setPhoneError(false);
  //   }
  // }, [clientPhone.number, clientPhone.country]);

  useEffect(() => {
    if (clientPhone.country && clientPhone.number !== "") {
      try {
        const parsedNumber = phoneUtil.parseAndKeepRawInput(
          clientPhone.number,
          clientPhone.country.iso,
        );

        const isValid = phoneUtil.isValidNumber(parsedNumber);
        const isPossible = phoneUtil.isPossibleNumber(parsedNumber);

        if (!isValid || !isPossible) {
          setcountrywithNumber(true);
          setMobileErr(false);
          return;
        } else {
          setcountrywithNumber(false);
        }
      } catch (err) {
        setcountrywithNumber(true);
        setMobileErr(false);
        return;
      }

      // Backend validation
      axios
        .post(fileurl + "/interface/register/validatephonenumber.php", {
          phone_number: clientPhone.number,
          country_code: clientPhone.country.iso,
        })
        .then((res) => {
          if (res.data === "invalid") {
            setMobileErr(true);
          } else {
            setMobileErr(false);
          }
        })
        .catch(() => {
          setMobileErr(false);
        });
    } else {
      setMobileErr(false);
      setcountrywithNumber(false);
    }
  }, [clientPhone.number, clientPhone.country]);
  useEffect(() => {}, []);

  useEffect(() => {
    let isCancelled = false;
    const handlechange = async () => {
      await timeout(1000);
      if (!isCancelled) {
        if (email_id !== "") {
          let data1 = Encrypt_Value(email_id, "vozo");
          axiosInstance
            .get("/vozonew/patmailcheck?search=" + data1)
            .then((res) => {
              let id = res.data.id;
              if (res.data === "Email not found") {
                setMailError1(false);
              } else if (id !== undefined || id !== "" || id !== null) {
                setMailError1(true);
                setMailErrorReq(false);

                setMailErrMsg("This E-mail Already Exists");
              } else {
                setMailError1(false);
              }
            });
        }
      }
    };
    handlechange();
    return () => {
      isCancelled = true;
    };
  }, [email_id]);

  // useEffect(() => {
  //   setphonenumber("");
  // }, [search]);

  useEffect(() => {
    const query = new URLSearchParams(Locationdata.search);
    const step = query.get("step");

    if (step === "23.4") {
      console.log("Opening Step 4 Tooltip");
      setIsIntakeFlow(true);
      setShowStepFourIntro(true);

      query.delete("step");

      history.replace({
        pathname: Locationdata.pathname,
        search: query.toString(),
      });
    } else if (step === "6.3") {
      setShowStepThreeIntro(true); // or whatever you want to trigger

      query.delete("step");
      history.replace({
        pathname: Locationdata.pathname,
        search: query.toString(),
      });
    }
  }, [Locationdata.search]);

  useEffect(() => {
    if (email_id && email_id.trim() !== "") {
      setPortalErrMsg("");
    }
    if (enablePortal && (!email_id || email_id.trim() === "")) {
      setEnablePortal(false);
    }
  }, [email_id, enablePortal]);

  useEffect(() => {
    if (!showStepThreeIntro && !showStepFourIntro) return;

    const modalBody = clientCreateRef.current?.querySelector(".modal-body");
    const modalRoot = clientCreateRef.current?.closest(".modal");
    const scrollContainers = [modalBody, modalRoot].filter(Boolean);
    if (scrollContainers.length === 0) return;

    const updatePopupPosition = () => {
      setModalScrollTick((prev) => prev + 1);
    };

    scrollContainers.forEach((container) => {
      container.addEventListener("scroll", updatePopupPosition, {
        passive: true,
      });
    });
    window.addEventListener("scroll", updatePopupPosition, { passive: true });
    window.addEventListener("resize", updatePopupPosition);

    return () => {
      scrollContainers.forEach((container) => {
        container.removeEventListener("scroll", updatePopupPosition);
      });
      window.removeEventListener("scroll", updatePopupPosition);
      window.removeEventListener("resize", updatePopupPosition);
    };
  }, [showStepThreeIntro, showStepFourIntro]);

  // ------------------------------- UseEffect End ------------------------------------------------------- //

  return (
    <div id="client-create" ref={clientCreateRef}>
      <Form>
        <Modal.Header closeButton>
          <Modal.Title className="table-top">Create Patient</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Row>
            <Form.Group as={Col} controlId="formGridEmail">
              <Popup
                offset={[80, 10]}
                content={
                  <GetStartedPopup
                    // title="Create your first patient"
                    title={
                      step === "23.4"
                        ? "Sending Intake Forms"
                        : "Create your first patient"
                    }
                    bullets={[
                      "Enter First & Last Name",
                      "Select Provider",
                      "To finish saving your patients click “Save” or to further fill their details click “Save & Fill more details”.",
                    ]}
                    currentStep={3}
                    totalSteps={6}
                    onNext={handleIntroNext}
                    onBack={handleIntroBack}
                    onClose={() => {
                      setShowStepThreeIntro(false);
                      handleClose();
                    }}
                    width="320px"
                  />
                }
                open={showStepThreeIntro}
                popperDependencies={[modalScrollTick]}
                className="m-t-10"
                trigger={
                  <div>
                    <Form.Label>
                      First Name<span style={{ color: "#E23D28" }}>*</span>
                    </Form.Label>
                    <Form.Control
                      name="first_name"
                      style={
                        fnError
                          ? { border: "1px solid red", borderRadius: "5px" }
                          : {}
                      }
                      value={first_name}
                      onChange={(e) => fnameSetVal(e)}
                      autoComplete="off"
                    />
                    {fnError ? (
                      <p className="errormessage">Invalid first name</p>
                    ) : (
                      ""
                    )}
                  </div>
                }
                position="left center"
              />
            </Form.Group>
            <Form.Group as={Col} controlId="formGridPassword">
              <Form.Label>
                Last Name<span style={{ color: "#E23D28" }}>*</span>
              </Form.Label>
              <Form.Control
                name="last_name"
                value={last_name}
                style={
                  lnError
                    ? { border: "1px solid red", borderRadius: "5px" }
                    : {}
                }
                onChange={(e) => lnameSetVal(e)}
                autoComplete="off"
              />
              {lnError ? <p className="errormessage">Invalid last name</p> : ""}
            </Form.Group>
          </Form.Row>
          <Form.Row>
            <Form.Group as={Col} className="client-form-control">
              <Form.Label>Email Address</Form.Label>
              <Form.Control
                name="email_id"
                value={email_id}
                style={
                  mailErrorVal || mailError1
                    ? { border: "1px solid red", borderRadius: "5px" }
                    : {}
                }
                onChange={EmailCheck}
                autoComplete="off"
              />
              {mailErrorVal || mailError1 ? (
                <p className="errormessage">{mailErrMsg}</p>
              ) : (
                ""
              )}
              {mailErrorReq && (
                <Div display="flex">
                  <Span marginright="5px" color="#F3282B">
                    Required for Patient Portal
                  </Span>
                  <Tooltip
                    className="for_tolltip_Phone_email"
                    title={
                      <Div radius="6px" width="320px">
                        <Div>
                          Without an email you might miss out functions like:
                        </Div>
                        <Div marginLeft="10px">
                          <Div>. Patient Portal</Div>
                          <Div>
                            . In Person & Telehealth Appointment Reminders
                          </Div>
                          <Div>. Email Notifications</Div>
                          <Div>. Billing Documents</Div>
                        </Div>
                      </Div>
                    }
                    overlayInnerStyle={{
                      backgroundColor: "#FFF", // Change background color
                      color: "#F3282B", // Change text color
                      width: "340px",
                      height: "136px",
                    }}
                  >
                    <Image
                      height="20px"
                      width="20px"
                      src={AlertMsgIcon}
                      alt="pic"
                      className="pat-image-right m-t-2"
                    />
                  </Tooltip>
                </Div>
              )}
            </Form.Group>
          </Form.Row>
          <Form.Row>
            <Form.Group as={Col}>
              <FormLabel
                color="#2d3748"
                fontWeight="500"
                fontFamily="'Open Sans', sans-serif"
                marginBottom="4px"
              >
                Phone Number
              </FormLabel>
              <Div display="flex" width="100%">
                {/* Autocomplete Start */}

                {/* <Div
                      className=" for_autoComplete_bi_Patient create-client-country-code pat-search-autocomplete for_contry_code create-client-config"
                      width="35%"
                      height="34px"
                      style={{ position: "relative" }}
                    > */}
                {/* <AiOutlineSearch /> */}
                {/* <AutoComplete
                        // open={true}
                        virtual={false}
                        getPopupContainer={(triggerNode) => triggerNode.parentNode}
                        onClick={mouseClick}
                        // onMouseLeave={handleMouseLeave}
                        placeholder="Country Code"
                        onSelect={changeCountryCode}
                        onSearch={handleSearchChange}
                        popupClassName={search !== "" ? "" : "for_no_loading"}
                        notFoundContent="No results found"
                        className="top-nav-pat-search mobcountry_radius"
                        id="top-nav-pat-search"
                        options={countryCodes
                          .filter((item) => {
                            let result = search.toLowerCase();
                            let s = String(item.full_details);

                            // Check if cleaned search matches either full_name or number
                            return s.toLowerCase().includes(result);
                          })
                          .map((x, index) => {
                            return {
                              label: x.full_details,
                              value: x.full_details,
                              key: x.number + "_" + index,
                            };
                          })}
                        value={search}
                        style={
                          countryErr
                            ? {
                                border: "1px solid red",
                                borderTopLeftRadius: "5px",
                                borderBottomLeftRadius: "5px",
                                borderRight: "none",
                              }
                            : {}
                        }
                      /> */}
                {/* <span
                        style={{
                          position: "absolute",
                          right: "10px",
                          top: "50%",
                          transform: "translateY(-50%)",
                          pointerEvents: "none",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <CustomSuffixIcon />
                      </span> */}
                {/* </Div> */}

                {/* Autocomplete End */}
                {/* <Input
                      ref={lastKeyPressed}
                      onKeyDown={(e) => (lastKeyPressed.current = e.key)}
                      height="34px"
                      fontFamily="'Open Sans', sans-serif"
                      color="#718096"
                      border="1px solid #D8E0F0"
                      paddingLeft="12px"
                      width="65%"
                      placeholder="Enter your number"
                      name="mobile"
                      btrr="4px"
                      bbrr="4px"
                      onChange={handleInput}
                      value={phone_number}
                      style={
                        mobileErr || countryErr || phoneError || countrywithNumber
                          ? { border: "1px solid red", borderTopRightRadius: "5px" }
                          : {}
                      }
                    /> */}
                <PhoneInput
                  value={clientPhone}
                  onChange={(val) => {
                    setClientPhone((prev) => ({
                      country: val.country ?? prev.country,
                      number: val.number ?? prev.number,
                    }));
                  }}
                />
              </Div>
              {mobileErr || phoneError ? (
                <p className="errormessage">Invalid Mobile number</p>
              ) : (
                ""
              )}
              {countryErr ? (
                <p className="errormessage">Invalid country code</p>
              ) : (
                ""
              )}
              {countrywithNumber && !countryErr ? (
                <p className="errormessage">Invalid Mobile Number</p>
              ) : (
                ""
              )}

              {clientPhone.number === "" && (
                <Div display="flex">
                  <Span marginright="5px" color="#F3282B">
                    Required for Patient Communication
                  </Span>
                  <Tooltip
                    className="for_tolltip_Phone_email"
                    title={
                      <Div radius="6px" width="320px">
                        <Div>
                          Without an phone number you might miss out functions
                          like:
                        </Div>
                        <Div marginLeft="10px">
                          <Div>
                            . In Person & Telehealth Appointment Reminders
                          </Div>
                        </Div>
                      </Div>
                    }
                    overlayInnerStyle={{
                      backgroundColor: "#FFF", // Change background color
                      color: "#F3282B", // Change text color
                      width: "340px",
                      height: "80px",
                    }}
                  >
                    <Image
                      height="20px"
                      width="20px"
                      src={AlertMsgIcon}
                      alt="pic"
                      className="pat-image-right m-t-2"
                    />
                  </Tooltip>
                </Div>
              )}
            </Form.Group>
          </Form.Row>
          <Form.Row>
            <Form.Group as={Col}>
              <Form.Label>External ID</Form.Label>
              <Form.Control
                id="pat_crt-inp_exId"
                name="external_id"
                value={externalID}
                onChange={externalId}
                autoComplete="off"
              />
            </Form.Group>
            <Col>
              <Form.Group className="force-width-createclient">
                <Form.Label>
                  Provider<span style={{ color: "#E23D28" }}>*</span>
                </Form.Label>

                <Select
                  virtual={false}
                  getPopupContainer={(triggerNode) => triggerNode.parentNode}
                  placeholder="Select Provider"
                  className="w-100 creat_provider ant-sel-hei34 FutVideoShow staterelative providerdropdown"
                  id="new-app-office"
                  value={providerID ? providerID : undefined}
                  // disabled={!storedNames.pat_g}
                  style={
                    provErr
                      ? { border: "1px solid red", borderTopRightRadius: "5px" }
                      : {}
                  }
                  onChange={(e) => provIdSetVal(e)}
                  suffixIcon={<CustomSuffixIcon />}
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    (option?.title ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                >
                  {providerlist.map((s, ind) => (
                    <Option
                      key={`29${ind}`}
                      value={s.id}
                      className={`crt_cln-pro_li${ind}`}
                      title={`${s.fname} ${s.lname}`}
                    >
                      {`${s.fname} ${s.lname}`}
                    </Option>
                  ))}
                </Select>
                {provErr ? (
                  <p className="errormessage">Please Select Provider</p>
                ) : (
                  ""
                )}
              </Form.Group>
            </Col>
          </Form.Row>
          {/* Add this right after the last <Form.Row> (External ID + Provider), before </Modal.Body> */}
          <div
            style={{
              margin: "20px 0 24px 0",
              paddingLeft: "12px",
            }}
          >
            <div
              style={{
                fontSize: "13.5px",
                color: "#64748b",
                lineHeight: "1.45",
                marginBottom: "10px",
                maxWidth: "460px",
              }}
            >
              By enabling the client portal access you can send forms &
              templates to the patients
            </div>
            <Popup
              open={showStepFourIntro}
              position="left center"
              pinned
              popperDependencies={[modalScrollTick]}
              content={
                <GetStartedPopup
                  title="Sending Intake Forms"
                  description="Add the patient details and click on 'Client Portal Access' to enable the patient portal."
                  currentStep={4}
                  totalSteps={9}
                  onBack={() => {
                    setShowStepFourIntro(false);

                    history.replace({
                      pathname: "/patient/patientlist",
                      search: "?step=23.3",
                    });

                    handleClose();
                  }}
                  onNext={() => {
                    setShowStepFourIntro(false);
                    openIntake({
                      id: 0,
                      name: first_name + " " + last_name,
                      email: email_id,
                    });
                  }}
                  onClose={() => {
                    setShowStepFourIntro(false);
                  }}
                />
              }
              trigger={
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    position: "relative",
                  }}
                >
                  <Switch
                    checked={enablePortal}
                    onChange={handlePortalChange}
                    size="default"
                  />
                  <span
                    style={{
                      fontSize: "14px",
                      fontWeight: "500",
                      color: "#2d3748",
                    }}
                  >
                    Enable Client Portal Access
                  </span>
                </div>
              }
            />
            {portalErrMsg && (
              <p className="errormessage" style={{ marginTop: "5px" }}>
                {portalErrMsg}
              </p>
            )}
          </div>
        </Modal.Body>

        <Modal.Footer
          className="client-button"
          style={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          <Button
            className="close_active close-btn"
            variant="outline-primary"
            onClick={handleClose}
          >
            Cancel
          </Button>
          <Button
            className="close_active fill-btn"
            variant="outline-primary"
            onClick={(e) => checkPhone(e, "more")}
            disabled={storedNames.demo1_viewOnly || storedNames.demo_v}
            style={{ minWidth: "260px" }}
          >
            Save and fill more details
          </Button>
          <Button
            className="save_active save-btn"
            variant="primary"
            disabled={
              disable || storedNames.demo1_viewOnly || storedNames.demo_v
            }
            onClick={(e) => checkPhone(e, "save")}
          >
            Save
          </Button>
        </Modal.Footer>
      </Form>

      {/* Phone Duplicate Error Modal (matches email error popup style) */}
      <Modal className="alert-popup-message" show={showPhoneFailModal}>
        <div className="alert msg alert-danger" role="alert">
          <IoCloseSharp className="icons-bs" />{" "}
          {phoneErrMsg ||
            "This phone number is already used for an existing patient. Please use a different phone number."}
        </div>
      </Modal>
    </div>
  );
};

export default memo(CreateClient);
